import React from 'react';

const GoogleSvgIcon = ({ size = 16, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M19.61 9.96664C19.61 9.16499 19.5449 8.57999 19.4042 7.97333H10.25V11.5916H15.6233C15.515 12.4908 14.93 13.845 13.63 14.7549L13.6118 14.8761L16.5061 17.1183L16.7067 17.1383C18.5483 15.4375 19.61 12.935 19.61 9.96664Z"
      fill="#4285F4"
    />
    <path
      d="M10.2501 19.5C12.8825 19.5 15.0925 18.6333 16.7067 17.1383L13.63 14.755C12.8067 15.3291 11.7017 15.73 10.2501 15.73C7.67174 15.73 5.48343 14.0292 4.70335 11.6783L4.58901 11.6881L1.5794 14.0172L1.54004 14.1266C3.14335 17.3116 6.43669 19.5 10.2501 19.5Z"
      fill="#34A853"
    />
    <path
      d="M4.70329 11.6783C4.49746 11.0717 4.37834 10.4216 4.37834 9.75C4.37834 9.07829 4.49746 8.42831 4.69246 7.82166L4.68701 7.69245L1.63968 5.32587L1.53997 5.37329C0.879171 6.69497 0.5 8.17917 0.5 9.75C0.5 11.3208 0.879171 12.8049 1.53997 14.1266L4.70329 11.6783Z"
      fill="#FBBC05"
    />
    <path
      d="M10.2501 3.76997C12.0809 3.76997 13.3158 4.5608 14.02 5.22168L16.7717 2.535C15.0817 0.96417 12.8825 0 10.2501 0C6.43669 0 3.14335 2.18832 1.54004 5.37329L4.69252 7.82165C5.48343 5.47083 7.67174 3.76997 10.2501 3.76997Z"
      fill="#EB4335"
    />
  </svg>
);

export default GoogleSvgIcon;
